import devImageKartik from "../../assets/kartikJha.jpg";
import devImageBiswa from "../../assets/biswa2.jpg";

export const DevDataObjKartik = {
  devRole: "Co-Founder, Full Stack Developer",
  devName: "Kartik Jha",
  devDesc: "Hello, here's my portfolio if you wanna have a look!",
  devImg: devImageKartik,
  portfolioHREF: "https://zephyris-port.web.app/",
};

export const DevDataObjVishwanath = {
  devRole: "Co-Founder, Blockchain Developer",
  devName: "Vishwanath Sharma",
  devDesc: " Hello, here's my portfolio if you wanna have a look!",
  devImg: devImageBiswa,
  portfolioHREF: "#",
};
